import { render, staticRenderFns } from "./vue-img-verify.vue?vue&type=template&id=bc4743b2"
import script from "./vue-img-verify.vue?vue&type=script&lang=ts"
export * from "./vue-img-verify.vue?vue&type=script&lang=ts"
import style0 from "./vue-img-verify.vue?vue&type=style&index=0&id=bc4743b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports